import { render } from "./Quotation5.vue?vue&type=template&id=1a651be8"
import script from "./Quotation5.vue?vue&type=script&lang=js"
export * from "./Quotation5.vue?vue&type=script&lang=js"
script.render = render

export default script